<template>
  <div class="fu-drtab" data-test="fu-drawer-broken">
    <p v-if="!items.length" class="fu-drtab__empty" data-test="fu-drawer-broken-empty">No broken appointments on file.</p>
    <div v-for="(it, i) in items" :key="i" class="fu-drtab__item">
      <div v-if="it.chip" class="fu-drtab__chip"><span>{{ it.chip.mon }}</span><strong>{{ it.chip.day }}</strong><small>{{ it.chip.yr }}</small></div>
      <div class="fu-drtab__main">
        <div class="fu-drtab__item-title">{{ it.title }}</div>
        <div v-if="it.meta" class="fu-drtab__meta">{{ it.meta }}</div>
      </div>
      <div class="fu-drtab__right"><strong>{{ it.right }}</strong><small>Fee</small></div>
    </div>
  </div>
</template>

<script>
/**
 * DrawerBrokenTab — "Broken history": today's Broken Appointment History (broken only): Date,
 * AdjustmentProcedureCode + BrokenAppointmentProcDescript, Fee, Provider. Presentational.
 */
import { dateChipOf } from '@/utils/followups/drawer/drawerFacts.js';

export default {
  name: 'DrawerBrokenTab',
  props: {
    tab: { type: Object, required: true },
    ctx: { type: Object, required: true },
  },
  computed: {
    items() {
      const s = (this.tab.sections || [])[0];
      const c = this.ctx;
      return ((s && s.rows) || []).map(r => ({
        chip: dateChipOf(r.Date),
        title: r.BrokenAppointmentProcDescript || r.AdjustmentProcedureCode || 'Broken appointment',
        meta: [r.AdjustmentProcedureCode || 'Adjustment', r.Provider || ''].filter(Boolean).join(' · '),
        right: r.Fee === null || r.Fee === undefined ? '—' : c.formatMoney(r.Fee),
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
@import './drawer';

.fu-drtab__empty { @include fu-dr-empty; }
.fu-drtab__item { @include fu-dr-item; }
.fu-drtab__main { flex: 1; min-width: 0; }
.fu-drtab__item-title { @include fu-dr-item-title; }
.fu-drtab__meta { @include fu-dr-item-meta; }

.fu-drtab__chip {
  @include fu-dr-date-chip;
  span { display: block; font-size: 10px; font-weight: $fu-fw-bold; letter-spacing: 0.06em; text-transform: uppercase; color: $fu-brand-600; }
  strong { display: block; font-size: 16px; font-weight: 800; }
  small { display: block; font-size: 10px; color: $fu-text-subtle; }
}

.fu-drtab__right {
  flex: none;
  text-align: right;
  strong { @include fu-tabular; display: block; font-size: 14px; font-weight: 800; }
  small { display: block; margin-top: 1px; font-size: 12px; color: $fu-text-muted; }
}
</style>
